<template>
    <b-popover :target="target" :show="true" triggers="hover focus" placement="top" container="body"
               boundary="viewport" :delay="{show: 0, hide: 250}" custom-class="timesheet-conflict-popover"
               @hidden="$emit('close', target)" @shown="focusIfRequested">
        <div ref="content" tabindex="-1" @keydown.esc.stop.prevent="closeAndFocus">
            <button type="button" class="close ml-2" aria-label="Закрыть подсказку" @click="closeAndFocus">×</button>
            <section v-for="day in days" :key="day.date" class="mb-2">
                <strong>{{ day.date.split('-').reverse().join('.') }}</strong>
                <div>В этом табеле: {{ day.local }}.</div>
                <p v-for="(message, index) in day.messages" :key="index" class="my-2">{{ message }}</p>
                <timesheet-conflict-sources :entries="day.entries" @open-author="$emit('close', target)" />
            </section>
        </div>
    </b-popover>
</template>

<script>
import TimesheetConflictSources from './TimesheetConflictSources.vue';
export default {
    components: {TimesheetConflictSources},
    props: {target: {required: true}, days: {type: Array, default: () => []}, focusContent: Boolean},
    watch: {focusContent() { this.$nextTick(this.focusIfRequested); }},
    methods: {
        focusIfRequested() {
            if (this.focusContent && this.$refs.content) this.$refs.content.focus();
        },
        closeAndFocus() {
            this.target.focus();
            this.$emit('close', this.target);
        }
    }
};
</script>

<style>
.timesheet-conflict-popover {
    max-width: min(440px, calc(100vw - 24px));
    background: rgba(0, 0, 0, .9);
    border: 0;
    border-radius: 6px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, .18);
}
.timesheet-conflict-popover .popover-body {
    max-height: 65vh;
    overflow-y: auto;
    overflow-wrap: anywhere;
    padding: 10px 12px;
    color: #fff;
    font-size: 14px;
    line-height: 1.45;
}
.timesheet-conflict-popover .popover-body a,
.timesheet-conflict-popover .popover-body .source-author {
    color: #fff;
    text-decoration: underline;
    text-underline-offset: 3px;
}
.timesheet-conflict-popover .popover-body a:hover,
.timesheet-conflict-popover .popover-body .source-author:hover { color: #b9dfff; }
.timesheet-conflict-popover .popover-body a:focus-visible,
.timesheet-conflict-popover .popover-body button:focus-visible { outline: 2px solid #b9dfff; outline-offset: 2px; }
.timesheet-conflict-popover .close { color: #fff; text-shadow: none; opacity: .7; }
.timesheet-conflict-popover .close:hover { opacity: 1; }
.timesheet-conflict-popover .arrow::before { border-color: transparent; }
.timesheet-conflict-popover.bs-popover-top > .arrow::after,
.timesheet-conflict-popover.bs-popover-auto[x-placement^="top"] > .arrow::after { border-top-color: rgba(0, 0, 0, .9); }
.timesheet-conflict-popover.bs-popover-bottom > .arrow::after,
.timesheet-conflict-popover.bs-popover-auto[x-placement^="bottom"] > .arrow::after { border-bottom-color: rgba(0, 0, 0, .9); }
.timesheet-conflict-popover.bs-popover-left > .arrow::after,
.timesheet-conflict-popover.bs-popover-auto[x-placement^="left"] > .arrow::after { border-left-color: rgba(0, 0, 0, .9); }
.timesheet-conflict-popover.bs-popover-right > .arrow::after,
.timesheet-conflict-popover.bs-popover-auto[x-placement^="right"] > .arrow::after { border-right-color: rgba(0, 0, 0, .9); }
</style>
